<template>
  <button class="emd-btn" :class="classList" @click="$emit('click')" :disabled="disabled">
    {{text}}
    <slot v-if="!text" />
  </button>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: false,
      default: null
    },
    color: {
      type: String,
      required: false,
      default: null
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      required: false,
      default: null
    },
    block: {
      type: Boolean,
      requiered: false,
      default: false
    }
  },
  computed: {
    classList () {
      var classList = []
      if (this.type) classList.push(`_type_${this.type}`)
      if (this.color) classList.push(`_color_${this.color}`)
      if (this.size) classList.push(`_size_${this.size}`)
      if (this.block) classList.push('_block')
      return classList
    }
  }
}
</script>
